import type { State } from "../State";
import { C1_MenubarActions } from "../../ConceptOne/src/components/C1_MenubarActions";
import type { PdfApplicationMode, PdfExportConfig, PdfChapterId } from "./PdfExportConfig";
import { createPlanExportSurface } from "./PlanExportSurface";

/** Runs the same chapter generators as Concept One with independent main-app settings and an isolated plan surface. */
export async function exportMainProjectPdf(
  app: State,
  input: PdfExportConfig,
  mode: PdfApplicationMode,
  singleChapterId?: PdfChapterId,
): Promise<void> {
  if (mode !== "main") throw new Error("Main-app PDF export requires main mode.");
  const runtime = app.c1;
  const original = {
    floorOwner: runtime._currentFloorOwner,
    floorId: runtime.currentFloorId.value,
    zoom: runtime.zoom.value,
    minZoom: runtime.minZoom.value,
    viewOffset: runtime.viewOffset.value,
    renderOptions: runtime.floorImageRenderOptions.value,
  };
  let surface: ReturnType<typeof createPlanExportSurface> | undefined;
  const actions = new C1_MenubarActions({
    getPlanElement: () => {
      surface ??= createPlanExportSurface();
      return surface.getPlanElement();
    },
    showInitialRoomPlacementPreview: () => {},
    beginPalettePointerPlacement: () => {},
    openRoombook: () => {},
    closeRoombook: () => {},
    isRoombookOpen: () => false,
  });
  try {
    await actions.confirmMasterPdf(input, mode, singleChapterId);
  } finally {
    surface?.dispose();
    runtime._currentFloorOwner = original.floorOwner;
    runtime.currentFloorId.value = original.floorId;
    runtime.zoom.value = original.zoom;
    runtime.minZoom.value = original.minZoom;
    runtime.viewOffset.value = original.viewOffset;
    runtime.floorImageRenderOptions.value = original.renderOptions;
  }
}
